<template>
  <div class="onboarding_page">
    <h2>Har ni en lista på medlemmar redan?</h2>
    <p>Ni har möjlighet att importera en lista från Excel med medlemmar.</p>
    <p>Innan ni gör detta bör ni skapa alla underföreningar som innehar medlemmar.</p>
    <p></p>
    <p></p>
    <p>
      <a href="/ml-import" target="_blank">Till Import >></a>
    </p>

    <h3 class="mt-4">Skapa importmall</h3>

    <p class="mt-4">Skapa en mall för importen skräddarsydd för er data genom att välja de fält som ni har i ert gamla system:</p>

    <GenerateImportExcelComponent />


    <div class="wizard_actions mt-4">
      <memlist-button variant="secondary" @click="prev_page">Tillbaka</memlist-button>
      <memlist-button variant="primary" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>

  </div>
</template>

<script>
import GenerateImportExcelComponent from './GenerateImportExcelComponent.vue'

export default {
  name: 'onboarding_page7',
  props: ['onboarding_data'],
  emits: ['next_page','prev_page','update_data'],
  components: {
    GenerateImportExcelComponent
  },
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
      },
      immediate: true
    },
  },
  data() {
    return {
      local_onboarding_data: null,
    }
  },
  methods: {
    next_page() {
      this.local_onboarding_data.generate_import_shown = true;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
